import { post_data } from './API_Calls.js';
import * as RO from './ReportObjects';

// Usage logging: one 'run' event per report open plus one event per export.
// Fire-and-forget — logging must never delay or break the report itself.

const report_type_names = { "0": "route_analysis", "1": "incidents", "2": "single_incident", "3": "vessel", "4": "timeline" };
const hosting_names = { "1": "vanguard", "2": "sedna", "3": "maritime" };

const url_params = new URL(window.location.href).searchParams;
export const run_uuid = (typeof crypto !== 'undefined' && crypto.randomUUID) ? crypto.randomUUID() : "";
let run_logged = false;

export const logReportUsage = (action, subject_name = "") => {
    try {
        if (action === 'run') {
            if (run_logged) return; // re-renders and StrictMode double-effects must not double-count a run
            run_logged = true;
        }
        post_data("/log_ReportUsage", {
            action: action,
            report_type: report_type_names[RO.report_type] || ("type_" + RO.report_type),
            user_uuid: RO.current_user || "",
            parent_account_uuid: RO.parent_uuid || "",
            source_app: "maritrace-reports",
            hosting: hosting_names[RO.white_label] || "maritrace",
            subject_uuid: RO.template_uuid || "",
            subject_name: subject_name || "",
            run_uuid: run_uuid,
            report_params: {
                coord: RO.coord_format || null,
                include_incidents: RO.include_incidents || null,
                incidents_radius: RO.incidents_radius || null,
                incidents_timespan: RO.incidents_timespan || null,
                imo: url_params.get('imo'),
                vessel_uuid: url_params.get('vesselUuid'),
                date_from: url_params.get('date_from'),
                date_to: url_params.get('date_to')
            }
        }).catch(() => {});
    } catch (e) {
        // never let usage logging surface to the user
    }
};
